import dayjs from 'dayjs';
import { Interview } from '../models/interview.model';

export type CalendarInterview = {
  interview: Interview;
  startsAt: string;
  endsAt?: string;
  isProposedSlot: boolean;
};

export const buildCalendarEntries = (
  interviews: Interview[]
): CalendarInterview[] => {
  const entries: CalendarInterview[] = [];

  for (const interview of interviews) {
    if (interview.confirmedStartsAt) {
      entries.push({
        interview,
        startsAt: interview.confirmedStartsAt,
        endsAt: interview.confirmedEndsAt,
        isProposedSlot: false,
      });
      continue;
    }

    if (interview.slots.length > 0) {
      for (const slot of interview.slots) {
        entries.push({
          interview,
          startsAt: slot.startsAt,
          endsAt: slot.endsAt,
          isProposedSlot: true,
        });
      }
      continue;
    }

    entries.push({
      interview,
      startsAt: interview.createdAt,
      isProposedSlot: true,
    });
  }

  return entries.sort(
    (left, right) =>
      dayjs(left.startsAt).valueOf() - dayjs(right.startsAt).valueOf()
  );
};
